<template>
    <section class="main" v-loading="isLoading">
        <plat-form-component @updateData="updateData" :option="{dateRadio: false}"></plat-form-component>
        <popular-product-component :salePlatform="salePlatform"></popular-product-component>
        <section class="box">
            <progress-product-component :salePlatform="salePlatform"></progress-product-component>
            <abnormal-product-component :salePlatform="salePlatform"></abnormal-product-component>
        </section>
        <product-analysis-component :salePlatform="salePlatform"></product-analysis-component>
        <tc-component v-if="showTc" :salePlatform="salePlatform" :productId="productId" :productName="productName" :startDateParams="startDate" :endDateParams="endDate"></tc-component>
    </section>
</template>

<style lang="scss" scoped="scoped">
    * {
        margin: 0;
        padding: 0;
    }
    .main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 0;
        .box {
            width: 98%;
            height: 500px;
            margin-top: 20px;
            margin-left: 1%;
        }
    }
</style>

<script>
    import PlatFormComponent from '../components/PlatForm.vue'
    import PopularProductComponent from './components/popular-product/PopularProduct.vue'
    import ProgressProductComponent from './components/progress-product/ProgressProduct.vue'
    import AbnormalProductComponent from './components/abnormal-product/AbnormalProduct.vue'
    import ProductAnalysisComponent from './components/product-analysis/ProductAnalysis.vue'
    import TcComponent from '../components/Tc.vue'
    import { eventBus } from 'helpers/index'

    export default {
        components: {
            PlatFormComponent,
            PopularProductComponent,
            ProgressProductComponent,
            AbnormalProductComponent,
            ProductAnalysisComponent,
            TcComponent
        },
        data () {
            const data = {
                salePlatform: 0, // 平台
                isLoading: false,
                showTc: false,   // 是否显示弹层
                productId: 0,
                productName: '',
                startDate: '',
                endDate: ''
            }
            return data;
        },
        methods: {
            // 更新数据
            updateData (params) {
                this.salePlatform = params.salePlatform;
            },

            // 改变弹层显示状态
            changeShowTc (status) {
                this.showTc = status;
            }
        },
        created () {
            eventBus.$on('showTc', params => {
                this.productId = params.productId;
                this.productName = params.productName;
                this.startDate = params.startDate;
                this.endDate = params.endDate;
                this.changeShowTc(true);
            })

            eventBus.$on('closeTc', () => {
                this.changeShowTc(false);
            })
        }
    }
</script>



// WEBPACK FOOTER //
// Main.vue?2e914578